import { cn } from '@/shadcn-ui/utils';

export default function getFormattedLabel(
  label: string,
  count?: number,
  disabled?: boolean
): string | React.ReactNode {
  return count !== undefined ? (
    <p
      className={cn('body', {
        'cursor-not-allowed text-flexcar-neutral80': disabled,
      })}
    >
      {label}{' '}
      <span
        className={cn({
          'text-flexcar-neutral60': !disabled,
          'text-flexcar-neutral80': disabled,
        })}
      >
        ({count})
      </span>
    </p>
  ) : (
    label
  );
}
